<template>
    <div class="item-container">
        <!-- <div>{{item}}</div>
        <div>{{item.value || '--'}}</div> -->
        <div class="item-title">{{item.title || '--'}}({{item.unit}})</div>
        <div class="item-value">
            <div v-for="(value, index) in item.value" :key="index" :style="colorStyle">
                {{value.name}}:{{value.value}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: Object,
    },
    computed: {
        colorStyle() {
            return {
                color: this.item.isDangerous ? '#FD4238': '#0D94FF'
            }
        }
    },
    filters: {
        numberFormatter: function (num) {
            const si = [
                { value: 1E9, symbol: 'G' },
                { value: 1E6, symbol: 'M' },
                { value: 1E3, symbol: 'k' }
            ];
            for (let i = 0; i < si.length; i++) {
                if (num >= si[i].value) {
                    return Number(num / si[i].value).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
                }
            }
            return num.toString()
        }
    }
}
</script>
<style lang="less" scoped>
.item-container {
    display: flex;
    .w(375);
    width: 100%;
    margin-top: 10px;
}
.item-title {
    width: 25%;

    font-size: 16rem;
    font-weight: 400;
    color: #666666;
}
.item-value {
    display: flex;
    width: 75%;
    
    font-size: 16rem;
    font-weight: 400;
}
.item-value>div {
    width: 30%;
}
</style>